import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ModuleHeader, { ModuleHeaderAction, ModuleHeaderBack } from "../../components/ModuleHeader/ModuleHeader";
import {
  createAdminMerchant,
  getAdminMerchant,
  updateAdminMerchant,
  updateAdminMerchantStatus,
} from "../../api/adminMerchantApi";
import { inactivateAdminOutlets } from "../../api/adminOutletApi";
import "./merchant-detail.scss";

const makeProduct = (overrides = {}) => ({
  name: "No product yet",
  description: "",
  price: "",
  prepTime: "",
  image: "",
  dailyQuantity: "",
  dailySold: "0",
  dailyResetTime: "12:00 AM",
  pickupStartTime: "",
  pickupEndTime: "",
  status: "Draft",
  ...overrides,
});

const makeOutlet = (overrides = {}) => ({
  name: "No outlet yet",
  city: "-",
  state: "Sarawak",
  postcode: "",
  address: "",
  latitude: "",
  longitude: "",
  googleMapUrl: "",
  phone: "",
  openTime: "",
  closeTime: "",
  lastOrderTime: "",
  acceptingOrders: "No",
  status: "Pending Setup",
  product: makeProduct(),
  ...overrides,
});

const merchantRecords = {
  "hikari-house": {
    name: "Hikari House",
    contact: "012-3456789",
    email: "hello@hikarihouse.my",
    city: "Kuching",
    address: "Lot 12, Kuching Central, Jalan Datuk Tawi Sli",
    pic: "Channie Tan",
    status: "Active",
    ordersToday: "12",
    salesToday: "226.80",
    paidOrders: "10",
    pendingOrders: "2",
    soldToday: "9",
    joinedDate: "12 Jun 2026",
    bank: "Maybank •••• 2188",
    bankName: "Maybank",
    bankReceiverName: "Hikari House Sdn Bhd",
    bankAccountNumber: "51422188",
    outlets: [
      makeOutlet({
        name: "Kuching Central",
        city: "Kuching",
        postcode: "93300",
        address: "Lot 12, Kuching Central, Jalan Datuk Tawi Sli",
        latitude: "1.5533",
        longitude: "110.3592",
        googleMapUrl: "https://maps.google.com/?q=1.5533,110.3592",
        phone: "012-3456789",
        openTime: "10:00 AM",
        closeTime: "8:00 PM",
        lastOrderTime: "7:30 PM",
        acceptingOrders: "Yes",
        status: "Active",
        product: makeProduct({
          name: "Chicken Katsu Bento",
          description: "Japanese chicken katsu bento with rice and side dish.",
          price: "12.90",
          prepTime: "15",
          dailyQuantity: "18",
          dailySold: "7",
          pickupStartTime: "5:30 PM",
          pickupEndTime: "7:30 PM",
          status: "Available",
        }),
      }),
      makeOutlet({
        name: "Saradise",
        city: "Kuching",
        postcode: "93350",
        address: "Saradise, Kuching",
        latitude: "1.5137",
        longitude: "110.3590",
        googleMapUrl: "https://maps.google.com/?q=1.5137,110.3590",
        phone: "012-3456799",
        openTime: "11:00 AM",
        closeTime: "8:30 PM",
        lastOrderTime: "8:00 PM",
        acceptingOrders: "Yes",
        status: "Active",
        product: makeProduct({
          name: "Teriyaki Bento",
          description: "Teriyaki chicken bento for Saradise outlet.",
          price: "13.90",
          prepTime: "15",
          dailyQuantity: "12",
          dailySold: "2",
          pickupStartTime: "5:30 PM",
          pickupEndTime: "7:30 PM",
          status: "Available",
        }),
      }),
    ],
  },
  "green-bowl": {
    name: "Green Bowl",
    contact: "011-2233445",
    email: "orders@greenbowl.my",
    city: "Kuching",
    address: "Ground Floor, Jalan Padungan, Kuching",
    pic: "Daniel Lim",
    status: "Active",
    ordersToday: "8",
    salesToday: "92.00",
    paidOrders: "7",
    pendingOrders: "1",
    soldToday: "5",
    joinedDate: "14 Jun 2026",
    bank: "CIMB •••• 7930",
    bankName: "CIMB",
    bankReceiverName: "Green Bowl Enterprise",
    bankAccountNumber: "80187930",
    outlets: [makeOutlet({
      name: "Padungan",
      city: "Kuching",
      postcode: "93100",
      address: "Ground Floor, Jalan Padungan, Kuching",
      latitude: "1.5580",
      longitude: "110.3518",
      googleMapUrl: "https://maps.google.com/?q=1.5580,110.3518",
      phone: "011-2233445",
      openTime: "10:30 AM",
      closeTime: "7:00 PM",
      lastOrderTime: "6:30 PM",
      acceptingOrders: "Yes",
      status: "Active",
      product: makeProduct({ name: "Healthy Rice Bowl", description: "Balanced rice bowl with vegetables and protein.", price: "11.50", prepTime: "12", dailyQuantity: "15", dailySold: "5", pickupStartTime: "5:00 PM", pickupEndTime: "7:00 PM", status: "Available" }),
    })],
  },
  "daily-bakery": {
    name: "Daily Bakery",
    contact: "016-9988776",
    email: "dailybakery@example.com",
    city: "Miri",
    address: "Lot 88, Miri Times Square",
    pic: "Mei Ling",
    status: "Pending Setup",
    ordersToday: "0",
    salesToday: "0.00",
    paidOrders: "0",
    pendingOrders: "0",
    soldToday: "0",
    joinedDate: "20 Jun 2026",
    bank: "Pending setup",
    bankName: "",
    bankReceiverName: "",
    bankAccountNumber: "",
    outlets: [],
  },
  "urban-cafe": {
    name: "Urban Cafe",
    contact: "019-7788990",
    email: "urban@example.com",
    city: "Sibu",
    address: "No. 18, Sibu Town Square",
    pic: "Alex Wong",
    status: "Inactive",
    ordersToday: "0",
    salesToday: "0.00",
    paidOrders: "0",
    pendingOrders: "0",
    soldToday: "0",
    joinedDate: "18 Jun 2026",
    bank: "Public Bank •••• 6621",
    bankName: "Public Bank",
    bankReceiverName: "Urban Cafe",
    bankAccountNumber: "30626621",
    outlets: [makeOutlet({
      name: "Sibu Town Square",
      city: "Sibu",
      postcode: "96000",
      address: "No. 18, Sibu Town Square",
      latitude: "2.2873",
      longitude: "111.8305",
      googleMapUrl: "https://maps.google.com/?q=2.2873,111.8305",
      phone: "019-7788990",
      openTime: "10:00 AM",
      closeTime: "6:00 PM",
      lastOrderTime: "5:30 PM",
      acceptingOrders: "No",
      status: "Inactive",
      product: makeProduct({ name: "Americano Combo", description: "Coffee combo for pickup.", price: "9.90", prepTime: "8", dailyQuantity: "0", dailySold: "0", pickupStartTime: "4:00 PM", pickupEndTime: "6:00 PM", status: "Hidden" }),
    })],
  },
};

const defaultMerchant = {
  name: "",
  code: "",
  contact: "",
  email: "",
  city: "Kuching",
  address: "",
  pic: "",
  status: "Pending Setup",
  ordersToday: "0",
  salesToday: "0.00",
  paidOrders: "0",
  pendingOrders: "0",
  soldToday: "0",
  joinedDate: "",
  bank: "",
  bankName: "",
  bankReceiverName: "",
  bankAccountNumber: "",
  outlets: [],
};

const statusClass = (value) => String(value).toLowerCase().replace(/\s+/g, "-");
const slugify = (value) => String(value).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
const formatPrice = (value) => (value && value !== "-" ? `RM${Number(value).toFixed(2)}` : "-");
const formatBankAccount = (bankName, accountNumber) => {
  if (!bankName && !accountNumber) return "Pending setup";
  if (!accountNumber) return bankName || "Pending setup";
  const digits = String(accountNumber).replace(/\s+/g, "");
  return `${bankName || "Bank"} •••• ${digits.slice(-4)}`;
};
const toDateInputValue = (value) => {
  if (!value) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(String(value))) return String(value).slice(0, 10);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const formatJoinedDate = (value) => {
  const iso = toDateInputValue(value);
  if (!iso) return value || "";
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value || "";
  return date.toLocaleDateString("en-MY", { day: "numeric", month: "short", year: "numeric" });
};
const todayDateInputValue = () => toDateInputValue(new Date());
const merchantStatusLabel = (status) => Number(status) === 1 ? "Active" : Number(status) === 2 ? "Pending Setup" : "Inactive";
const merchantStatusValue = (status) => status === "Active" ? 1 : status === "Pending Setup" ? 2 : 0;
const markOutletsInactive = (merchant) => ({
  ...merchant,
  outlets: (merchant.outlets || []).map((outlet) => ({ ...outlet, status: "Inactive" })),
});
const applyInactiveOutlets = async (id) => {
  await inactivateAdminOutlets(id);
  return markOutletsInactive(mapApiMerchant(await getAdminMerchant(id)));
};
const mapApiMerchant = (record) => ({
  name: record.name || "",
  code: record.code || "",
  contact: String(record.phone || "").replace(/\D/g, ""),
  email: record.email || "",
  city: record.city || "",
  address: record.address || "",
  pic: record.person_in_charge || "",
  status: merchantStatusLabel(record.status),
  ordersToday: String(record.orders_today || 0),
  salesToday: String(record.sales_today || 0),
  paidOrders: String(record.paid_orders_today || 0),
  pendingOrders: String(record.pending_orders_today || 0),
  soldToday: String(record.sold_today || 0),
  joinedDate: toDateInputValue(record.created_at) || "",
  bankName: record.bank_name || "",
  bankReceiverName: record.bank_receiver_name || "",
  bankAccountNumber: record.bank_account_number || "",
  outlets: (record.outlets || []).map((outlet) => makeOutlet({
    id: outlet.id,
    name: outlet.name,
    city: outlet.city || "-",
    address: outlet.address || "",
    status: Number(outlet.status) === 1 ? "Active" : "Inactive",
    product: outlet.product ? makeProduct({
      id: outlet.product.id,
      name: outlet.product.name,
      status: Number(outlet.product.status) === 1 ? "Available" : "Hidden",
    }) : makeProduct(),
  })),
});
const timeToInput = (value) => {
  if (!value) return "";
  const match = String(value).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
  if (!match) return value;
  let hour = Number(match[1]);
  const minute = match[2];
  const period = match[3]?.toUpperCase();
  if (period === "PM" && hour < 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return `${String(hour).padStart(2, "0")}:${minute}`;
};
const inputToTime = (value) => {
  if (!value) return "";
  const [hourText, minute] = value.split(":");
  let hour = Number(hourText);
  const period = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${period}`;
};

const INVENTORY_RULES = {
  resetAutomatically: true,
  reduceQuantityOn: ["On Hold", "On Paid"],
  restoreQuantityOn: ["Cancelled", "Payment Timeout"],
};

const InfoItem = ({ label, value }) => (
  <div className="merchant-detail__info-item"><span>{label}</span><strong>{value || "-"}</strong></div>
);

const TextField = ({ label, value, onChange, placeholder, type = "text", readOnly = false, helpText, inputMode, maxLength }) => (
  <label className={`merchant-detail__field${readOnly ? " merchant-detail__field--readonly" : ""}`}>
    <span>{label}</span>
    <input
      type={type}
      value={value || ""}
      placeholder={placeholder}
      readOnly={readOnly}
      aria-readonly={readOnly}
      inputMode={inputMode}
      maxLength={maxLength}
      onChange={(event) => !readOnly && onChange?.(event.target.value)}
    />
    {helpText && <small>{helpText}</small>}
  </label>
);

const TimeField = ({ label, value, onChange }) => (
  <label className="merchant-detail__field"><span>{label}</span><input type="time" value={timeToInput(value)} onChange={(event) => onChange(inputToTime(event.target.value))} /></label>
);

const ImageUploadField = ({ label, value, onChange }) => {
  const hasPreview = value && String(value).startsWith("blob:");
  return (
    <label className="merchant-detail__field merchant-detail__field--upload">
      <span>{label}</span>
      <input type="file" accept="image/png,image/jpeg,image/webp" onChange={(event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        onChange({ fileName: file.name, previewUrl: URL.createObjectURL(file) });
      }} />
      <div className="merchant-detail__upload-box">
        {hasPreview ? <img src={value} alt="Product preview" /> : <strong>{value || "Choose product image"}</strong>}
        <small>PNG, JPG, or WebP. The API upload can be connected later.</small>
      </div>
    </label>
  );
};

const Modal = ({ title, description, children, onClose, onSave, saveLabel = "Save" }) => (
  <div className="merchant-detail__modal-backdrop" role="presentation">
    <div className="merchant-detail__modal" role="dialog" aria-modal="true" aria-label={title}>
      <div className="merchant-detail__modal-header"><div><h3>{title}</h3>{description && <p>{description}</p>}</div><button type="button" onClick={onClose}>×</button></div>
      <div className="merchant-detail__modal-body">{children}</div>
      <div className="merchant-detail__modal-footer"><button className="merchant-detail__secondary-btn" type="button" onClick={onClose}>Cancel</button><button className="merchant-detail__primary-btn" type="button" onClick={onSave}>{saveLabel}</button></div>
    </div>
  </div>
);

const MerchantDetailPage = ({ mode = "view" }) => {
  const navigate = useNavigate();
  const { merchantId } = useParams();
  const isCreate = mode === "create" || merchantId === "create";
  const isEdit = mode === "edit" || isCreate;
  const [merchant, setMerchant] = useState(defaultMerchant);
  const [loading, setLoading] = useState(!isCreate);
  const [saving, setSaving] = useState(false);
  const [selectedOutletIndex, setSelectedOutletIndex] = useState(0);
  const [draftOutlet, setDraftOutlet] = useState(makeOutlet());
  const [draftProduct, setDraftProduct] = useState(makeProduct());
  const [activeModal, setActiveModal] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (isCreate) {
      setMerchant({ ...defaultMerchant, joinedDate: todayDateInputValue() });
      setLoading(false);
      return;
    }

    const loadMerchant = async () => {
      setLoading(true);
      setMessage("");
      try {
        setMerchant(mapApiMerchant(await getAdminMerchant(merchantId)));
      } catch (error) {
        setMessage(error.message);
      } finally {
        setLoading(false);
      }
    };
    loadMerchant();
  }, [isCreate, merchantId]);

  const outlets = merchant.outlets || [];
  const selectedOutlet = outlets[selectedOutletIndex] || outlets[0] || makeOutlet();
  const selectedProduct = selectedOutlet.product || makeProduct();
  const activeProductCount = outlets.filter((outlet) => outlet.product?.status === "Available").length;
  const outletCount = outlets.length;
  const totalDailyQuantity = outlets.reduce((sum, outlet) => sum + Number(outlet.product?.dailyQuantity || 0), 0);
  const totalDailySold = outlets.reduce((sum, outlet) => sum + Number(outlet.product?.dailySold || 0), 0);

  const updateMerchant = (field, value) => setMerchant((current) => {
    const next = { ...current, [field]: value };
    if (["bankName", "bankAccountNumber"].includes(field)) next.bank = formatBankAccount(next.bankName, next.bankAccountNumber);
    return next;
  });
  const updateOutlet = (field, value) => setDraftOutlet((current) => ({ ...current, [field]: value }));
  const updateProduct = (field, value) => setDraftProduct((current) => ({ ...current, [field]: value }));

  const openAddOutletModal = () => {
    setDraftOutlet(makeOutlet({ phone: merchant.contact, city: merchant.city || "Kuching" }));
    setActiveModal("outlet-add");
  };
  const openEditOutletModal = (index = selectedOutletIndex) => {
    setSelectedOutletIndex(index);
    setDraftOutlet(outlets[index] || makeOutlet());
    setActiveModal("outlet-edit");
  };
  const openProductModal = (index = selectedOutletIndex) => {
    setSelectedOutletIndex(index);
    setDraftProduct((outlets[index] || makeOutlet()).product || makeProduct());
    setActiveModal("product");
  };

  const merchantPayload = () => ({
    name: merchant.name,
    phone: merchant.contact || null,
    person_in_charge: merchant.pic || null,
    address: merchant.address || null,
    city: merchant.city || null,
    bank_name: merchant.bankName || null,
    bank_receiver_name: merchant.bankReceiverName || null,
    bank_account_number: merchant.bankAccountNumber || null,
    timezone: "Asia/Kuching",
    currency: "MYR",
    status: merchantStatusValue(merchant.status),
  });
  const handleSave = async () => {
    setSaving(true);
    setMessage("");
    try {
      const saved = isCreate
        ? await createAdminMerchant(merchantPayload())
        : await updateAdminMerchant(merchantId, merchantPayload());
      let mapped = mapApiMerchant(saved);
      if (!isCreate && merchantStatusValue(merchant.status) === 0) {
        mapped = await applyInactiveOutlets(merchantId);
      }
      setMerchant(mapped);
      if (isCreate) {
        navigate(`/merchants/${saved.id}`, { replace: true });
      } else {
        navigate(`/merchants/${merchantId}`, { replace: true });
      }
    } catch (error) {
      setMessage(error.message);
    } finally {
      setSaving(false);
    }
  };
  const saveOutlet = () => {
    setMerchant((current) => {
      const nextOutlets = [...(current.outlets || [])];
      if (activeModal === "outlet-add") {
        nextOutlets.push({ ...draftOutlet, product: draftOutlet.product || makeProduct() });
        setSelectedOutletIndex(nextOutlets.length - 1);
      } else {
        nextOutlets[selectedOutletIndex] = { ...draftOutlet, product: nextOutlets[selectedOutletIndex]?.product || makeProduct() };
      }
      return { ...current, city: nextOutlets[0]?.city || current.city, outlets: nextOutlets };
    });
    setActiveModal(null);
    setMessage("Outlet setup saved. Merchants can have multiple outlets, but only admin can create or manage outlets.");
  };
  const saveProduct = () => {
    setMerchant((current) => {
      const nextOutlets = [...(current.outlets || [])];
      nextOutlets[selectedOutletIndex] = { ...(nextOutlets[selectedOutletIndex] || makeOutlet()), product: draftProduct };
      return { ...current, outlets: nextOutlets };
    });
    setActiveModal(null);
    setMessage("Product setup saved. Each outlet is restricted to one product for this MVP.");
  };
  const handleSendSetupEmail = () => setMessage(`Welcome email prepared for ${merchant.email || "this merchant"}. It contains the portal link, login email, temporary password, and setup steps.`);
  const handleDeactivate = async () => {
    setSaving(true);
    setMessage("");
    try {
      const nextStatus = merchant.status === "Inactive" ? 1 : 0;
      await updateAdminMerchantStatus(merchantId, nextStatus);
      if (nextStatus === 0) {
        setMerchant(await applyInactiveOutlets(merchantId));
        setMessage("Merchant deactivated. All outlets were set to inactive.");
      } else {
        setMerchant(mapApiMerchant(await getAdminMerchant(merchantId)));
        setMessage("Merchant reactivated.");
      }
    } catch (error) {
      setMessage(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="merchant-detail">
      <ModuleHeader
        bleed
        variant={merchant.status === "Inactive" ? "danger" : "default"}
        title={isCreate ? "Create Merchant" : merchant.name}
        description={
          isCreate
            ? "Add a merchant profile first. Admin can add multiple outlets after the merchant is created."
            : "Review merchant profile, multiple outlet setup, one product per outlet, and order activity."
        }
        back={(
          <ModuleHeaderBack type="button" onClick={() => navigate("/merchants")}>
            ← Back to Merchants
          </ModuleHeaderBack>
        )}
        actions={(
          <>
            {!isCreate && (
              <ModuleHeaderAction
                type="button"
                variant={merchant.status === "Inactive" ? "success" : "danger"}
                onClick={handleDeactivate}
                disabled={saving}
              >
                {merchant.status === "Inactive" ? "Activate Merchant" : "Deactivate Merchant"}
              </ModuleHeaderAction>
            )}
            {!isEdit && (
              <ModuleHeaderAction type="button" onClick={() => navigate(`/merchants/${merchantId}/edit`)}>
                Edit Merchant
              </ModuleHeaderAction>
            )}
            {isEdit && (
              <ModuleHeaderAction type="button" onClick={handleSave} disabled={loading || saving}>
                {saving ? "Saving..." : "Save Merchant"}
              </ModuleHeaderAction>
            )}
          </>
        )}
      />

      {message && <div className="merchant-detail__notice">{message}</div>}

      <section className="merchant-detail__summary-grid">
        <InfoItem label="Contact" value={merchant.contact} />
        <InfoItem label="City / Area" value={merchant.city} />
        <InfoItem label="Outlets" value={`${outletCount} outlet${outletCount === 1 ? "" : "s"}`} />
        <InfoItem label="Products" value={`${activeProductCount} active`} />
      </section>

      <section className="merchant-detail__content-grid">
        <div className="merchant-detail__panel merchant-detail__panel--wide">
          <div className="merchant-detail__panel-title"><h3>Merchant Profile</h3></div>
          {isEdit ? (
            <div className="merchant-detail__form-grid">
              <TextField label="Merchant Name" value={merchant.name} placeholder="Enter merchant name" onChange={(value) => updateMerchant("name", value)} />
              <TextField label="Code" value={merchant.code} placeholder="Assigned after save" readOnly />
              <TextField
                label="Contact Number"
                type="tel"
                inputMode="numeric"
                maxLength={15}
                value={merchant.contact}
                placeholder="0123456789"
                onChange={(value) => updateMerchant("contact", value.replace(/\D/g, ""))}
              />
              <TextField label="Person In Charge" value={merchant.pic} placeholder="PIC name" onChange={(value) => updateMerchant("pic", value)} />
              <TextField label="Address" value={merchant.address} placeholder="Merchant billing address" onChange={(value) => updateMerchant("address", value)} />
              <TextField
                label="Joined Date"
                type="date"
                value={toDateInputValue(merchant.joinedDate) || todayDateInputValue()}
                onChange={(value) => updateMerchant("joinedDate", value)}
              />
              <TextField label="Bank Name" value={merchant.bankName} placeholder="Maybank" onChange={(value) => updateMerchant("bankName", value)} />
              <TextField label="Receiver Name" value={merchant.bankReceiverName} placeholder="Account receiver name" onChange={(value) => updateMerchant("bankReceiverName", value)} />
              <TextField label="Account Number" value={merchant.bankAccountNumber} placeholder="51422188" onChange={(value) => updateMerchant("bankAccountNumber", value)} />
              <label className="merchant-detail__field"><span>Status</span><select value={merchant.status} onChange={(event) => updateMerchant("status", event.target.value)}><option>Active</option><option>Inactive</option><option>Pending Setup</option></select></label>
            </div>
          ) : (
            <div className="merchant-detail__profile-grid">
              <InfoItem label="Merchant Name" value={merchant.name} />
              <InfoItem label="Merchant Code" value={merchant.code} />
              <InfoItem label="Person In Charge" value={merchant.pic} />
              <InfoItem label="Joined Date" value={formatJoinedDate(merchant.joinedDate)} />
              <InfoItem label="Address" value={merchant.address} />
              <InfoItem label="Bank Name" value={merchant.bankName} />
              <InfoItem label="Receiver Name" value={merchant.bankReceiverName} />
              <InfoItem label="Account Number" value={merchant.bankAccountNumber} />
            </div>
          )}
        </div>

        <div className="merchant-detail__panel merchant-detail__panel--wide">
          <div className="merchant-detail__panel-title"><h3>Sales Summary</h3><p>Today's sales snapshot across all outlets.</p></div>
          <div className="merchant-detail__sales-grid">
            <InfoItem label="Sales Today" value={formatPrice(merchant.salesToday)} />
            <InfoItem label="Total Orders" value={merchant.ordersToday} />
            <InfoItem label="Paid Orders" value={merchant.paidOrders} />
            <InfoItem label="Pending Orders" value={merchant.pendingOrders} />
            <InfoItem label="Total Daily Quantity" value={totalDailyQuantity || "-"} />
            <InfoItem label="Total Daily Sold" value={totalDailySold || merchant.soldToday || "0"} />
          </div>
        </div>

        <div className="merchant-detail__panel merchant-detail__panel--wide">
          <div className="merchant-detail__panel-title merchant-detail__panel-title--with-action">
            <div>
              <h3>Outlets Summary</h3>
              <p>Outlet setup and product setup have moved to the outlet detail page.</p>
            </div>
            {!isCreate && (
              <button
                type="button"
                className="merchant-detail__primary-btn"
                onClick={() => navigate(`/merchants/${merchantId}/outlets/create`)}
              >
                + Add Outlet
              </button>
            )}
          </div>
          <div className="merchant-detail__table">
            <div className="merchant-detail__table-head merchant-detail__table-head--outlets"><span>Outlet</span><span>City</span><span>Product</span><span>Status</span><span>Action</span></div>
            {!loading && outlets.length ? outlets.map((outlet, index) => (
              <div className={`merchant-detail__table-row merchant-detail__table-row--outlets${selectedOutletIndex === index ? " merchant-detail__table-row--selected" : ""}`} key={`${outlet.name}-${index}`} onClick={() => setSelectedOutletIndex(index)}>
                <span>{outlet.name || "No outlet yet"}</span>
                <span>{outlet.city || "-"}</span>
                <span>{outlet.product?.name || "No product yet"}</span>
                <span className={`merchant-detail__status merchant-detail__status--${statusClass(outlet.status)}`}>{outlet.status}</span>
                <span><button className="merchant-detail__link-btn" type="button" onClick={(event) => { event.stopPropagation(); navigate(`/merchants/${merchantId}/outlets/${outlet.id}`); }}>View Outlet</button></span>
              </div>
            )) : <div className="merchant-detail__table-empty">{loading ? "Loading merchant..." : "No outlet yet. Create outlets from the outlet page."}</div>}
          </div>
        </div>
      </section>

    </div>
  );
};

export default MerchantDetailPage;
